import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Video, ArrowUp } from 'lucide-react';
import './ButtonsSection.css';
import useSectionInView from '../useSectionInView';
import '../sectionAnimations.css';

export default function ButtonsSection() {
  const [ref, visible] = useSectionInView();
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDemo = () => {
    // כרגע לא עושה כלום
    console.log('Demo clicked');
  };

  const handleAllPrograms = () => {
    navigate('/programs');
  };

  return (
    <section ref={ref} className={`home-buttons-section home-buttons-section flex flex-wrap justify-center gap-4 mt-12 section-slide-in-right${visible ? ' visible' : ''}`}>
      <button className="btn-secondary flex items-center px-4 py-1.5 gap-2 h-10.5" onClick={handleAllPrograms}>
        <ArrowLeft className="w-5 h-5 text-white" />
        לכל התוכניות
      </button>
      <button className="btn-outline-green flex items-center px-4 py-1.5 gap-2 h-10.5 rounded-lg" onClick={handleDemo}>
        <Video className="w-5 h-5" />
        לצפייה בהדגמה
      </button>
      <button className="btn-secondary flex items-center px-4 py-1.5 gap-2 h-10.5" onClick={scrollToTop}>
        <ArrowUp className="w-5 h-5 text-white" />
        לראש הדף
      </button>
    </section>
  );
}



